<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import SelectWarehouse from '@components/retina/inventory/SelectWarehouse'
import CountInventory from '@components/retina/inventory/CountInventory'
import OnlineInventory from '@components/retina/inventory/OnlineInventory'
import CountReview from '@components/retina/inventory/CountReview'
import CountSpentProducts from '@components/retina/inventory/CountSpentProducts'
import Pointer from '@components/retina/inventory/Pointer'
import { mapGetters } from 'vuex'
import { inventoryMethods, warehouseMethods } from '@state/helpers'

export default {
  name: 'Inventario',
  page: {
    title: 'Inventario',
    meta: [{ name: 'Inventario', content: 'Inventario' }],
  },
  components: {
    Layout,
    PageHeader,
    SelectWarehouse,
    CountInventory,
    OnlineInventory,
    CountReview,
    CountSpentProducts,
    Pointer,
  },
  data() {
    return {
      title: '<i class="fas fa-truck"></i> Inventario',
      items: [
        { 
          text: 'Inventario',
          active: true,
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      warehouse_selected: 'retina/warehouse/warehouse_selected',
      ubication_selected: 'retina/warehouse/ubication_selected',
      warehouse_i: 'retina/inventory/warehouse_i',
      ubication_i: 'retina/inventory/ubication_i',
      consult_warehouse: 'retina/warehouse/consult_warehouse',
      inventory_count_mode: 'retina/inventory/inventory_count_mode',
      inventory_count_spent_products: 'retina/inventory/inventory_count_spent_products',
      inventory_count_review: 'retina/inventory/inventory_count_review',
      inventory_online_mode: 'retina/inventory/inventory_online_mode',
    }),
  },
  methods: {
    ...inventoryMethods,
    ...warehouseMethods,

    consultWarehouse() {
      return (!this.warehouse_selected || !this.ubication_selected) && (!this.warehouse_i && !this.ubication_i) ? true 
        : this.inventory_count_mode
        ? false
        : this.inventory_count_review
        ? false
        : this.inventory_online_mode
        ? false
        : this.inventory_count_spent_products
        ? false
        : true
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Pointer />

    <SelectWarehouse v-if="consultWarehouse()" />

    <CountInventory v-if="inventory_count_mode" />

    <CountSpentProducts v-if="inventory_count_spent_products"/>

    <CountReview v-if="inventory_count_review" />

    <OnlineInventory v-if="inventory_online_mode" />
  </Layout>
</template>
